import { net_filemanage } from "@/api/http";

export const API_STFMFM02C20_DeleteOther = (...params) =>
net_filemanage.post("/api/STFMFM02C20/DeleteOther", ...params);
